import { ClinicInformationState } from "./type";
import { ILabelSelect } from "../../services/Language/Types";
import { ApplicationState } from "..";
import { IHealthCardParser } from "../../services/HealthCardBarcodeScanParsers/BaseHealthCardParser";
import { HealthCardParserSelector } from "../../services/HealthCardBarcodeScanParsers/HealthCardParserSelector";
import { AdminOptionsState } from "../AdminOptions/type";

export const getClinicName = (state: ClinicInformationState) => {
    return state.clinicName;
}

export const getClinicCountry = (state: ClinicInformationState): string => {
    return state.clinicCountry;
}

export const getClinicRegion = (state: ClinicInformationState) => {
    return state.clinicRegion;
}

export const getIntroductionText = (state: ClinicInformationState) => {
    const introText = {};
    introText["en"] = state.enText || "";
    introText["fr"] = state.frText || "";
    introText["es"] = state.esText || "";
    return introText;
}

export const getSitesList = (state: ClinicInformationState, adminState: AdminOptionsState): ILabelSelect[] => {
    return state.sites.map(site => ({
        label: site.name,
        value: site.id,
        checked: adminState.multiSiteIds && adminState.multiSiteIds.has(site.id) ? true : false,
        parentSiteId: site.parentSiteId
    }));
};

export const getHealthCardParsers = (state: ClinicInformationState): IHealthCardParser[] => {
    const parsers: IHealthCardParser[] = [];

    for (const healthCard of state.healthCards) {
        parsers.push(HealthCardParserSelector.GetParser(healthCard.cardTypeCode));
    }

    return parsers.filter(parser => !!parser);
}

export const getIsDebugWindowEnabledForSaga = (state: ApplicationState) => state.clinicInformation.featureFlags.debugWindowModeEnabled;


// WEBPACK FOOTER //
// ./src/store/ClinicInformation/selectors.ts